import http from '@/utils/request'

 export default {
  querySysConfig: {
    url: 'kfcloud-crm/sysConfig/querySysConfig',
    name: '基本配置',
    post: async function(data, config={}) {
      return await http.post(this.url, data, config)
    }
  },
  fileServerHealthCheck: {
    url: '/manage/health',
    name: '检查文件服务器',
    get: async function (params) {
      return await http.get(params + this.url, {})
    }
  },
  // queryLoginUser: {
  //   url: 'kfcloud-crm/system/user/queryLoginUser',
  //   name: '登录用户信息',
  //   post: async function(data, config={}) {
  //     return await http.post(this.url, data, config)
  //   }
  // },
  getInfo: {
    url: 'oms/findLoginUser',
    name: '登录用户信息',
    get: async function(params) {
      return await http.get(this.url, params)
    }
  },
  getDictList: {
    url: '/dict/getMainList',
    name: '字典项',
    post: async function(data) {
      return await http.post(this.url, data)
    }
  },
  getProvince: {
    url: 'system/region/findRegions',
    name: '省市区',
    post: async function(data) {
      return await http.post(this.url, data)
    }
  },
  updateAvatar: {
    url: 'system/user/profile/avatar',
    name: '上传头像',
    post: async function(data, config={headers:{'Content-Type': 'multipart/form-data;charset=UTF-8'}}) {
      return await http.post(this.url, data, config)
    }
  },
  selectedDownload: {
    url: 'common/universal/download',
    name: '导出选中',
    post: async function(data, config={responseType: 'blob'}) {
      return await http.post(this.url, data, config)
    }
  },
  downloadAll: {
    url: 'common/download/list',
    name: '导出全部',
    post: async function(data) {
      return await http.post(this.url, data)
    }
  },
  downloadList: {
    url: 'common/async/download/list',
    name: '上传下载列表',
    post: async function(data) {
      return await http.post(this.url, data)
    }
  },
  downloadDel: {
    url: 'common/remove/file',
    name: '上传下载列表删除',
    post: async function(data) {
      return await http.post(this.url, data)
    }
  },
  getUserMenu: {
    url: 'system/menu/list',
    name: '获取登录用户菜单信息',
    get: async function(params) {
      return await http.get(this.url, params)
    }
  }
}
